import { useContext, createContext } from 'react';

function getProvider<T>(): {
  StoreProvider: React.Provider<T | null>;
  useStore: () => T;
} {
  const RootStoreContext = createContext<null | T>(null);

  const StoreProvider = RootStoreContext.Provider;
  function useStore(): T {
    const store = useContext(RootStoreContext);
    if (store === null) {
      throw new Error('Store cannot be null, please add a context provider');
    }
    return store;
  }
  return { StoreProvider, useStore };
}

export default getProvider;
